var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Cancel as IconCancel } from "@mui/icons-material";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { useStyles } from "./ui_chip.css";
export const UiChip = (_a) => {
    var { deleteTooltip, isLoading } = _a, props = __rest(_a, ["deleteTooltip", "isLoading"]);
    const classes = useStyles();
    return (_jsx(Chip, Object.assign({ deleteIcon: isLoading ? (_jsx(CircularProgress, { className: classes.circular, color: "inherit", size: 16 })) : (_jsx(Tooltip, { title: deleteTooltip || "", children: _jsx(IconCancel, {}) })) }, props)));
};
//# sourceMappingURL=ui_chip.js.map